








































import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { MasterDataActionsEnum, SnackbarStateEnum } from '@/types/enums'
import { CalendarEvent } from '@/model/planning/CalendarEvent'
import CalendarEventSettingsDialog from '@/components/settings/CalendarEventSettingsDialog.vue'
import ColorCellRenderer from '@/components/cell-renderer/ColorCellRenderer.vue'
import BooleanCellRenderer from '@/components/cell-renderer/BooleanCellRenderer.vue'
import {
  COMPANY_FETCH_PROFIT_CENTER_CALENDAR_EVENTS,
  COMPANY_UPDATE_DELETE_CALENDAR_EVENT
} from '@/store/action-types'
import {
  CalendarEventSettingsPayload,
  CalendarEventPayload
} from '@/types/payload'
import { GridOptions } from '@/types'
import { hexToRgba } from '@/services/hex-to-rgba'
import { TranslateResult } from 'vue-i18n'

interface ComponentData {
  show: boolean
  gridData: Array<CalendarEvent>
  gridOptions: GridOptions
  action: MasterDataActionsEnum | undefined
  currentSelectedRowId: string
  currentSelectedEvent: CalendarEvent | undefined
  gridFrameworkComponents: Object
  loading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  overlayNoRowsTemplate: string
}

export default Vue.extend({
  name: 'CalendarEventPage',

  components: {
    AgGridVue,
    CalendarEventSettingsDialog
  },

  props: {
    profitCenterId: Number,
    profitCenterCode: String
  },

  watch: {
    profitCenterId (newVal: number): void {
      if (newVal) {
        this.currentSelectedRowId = ''
        this.currentSelectedEvent = undefined
        this.fetchCalendarEventList()
      }
    }
  },

  data (): ComponentData {
    return {
      action: undefined,
      currentSelectedRowId: '',
      currentSelectedEvent: undefined,
      show: false,
      gridData: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('calendarEventSettings.event'), field: 'eventName', width: 300 },
          {
            headerName: this.$t('calendarEventSettings.color'),
            field: 'color',
            cellRenderer: 'colorRenderer',
            width: 300
          },
          {
            headerName: this.$t('calendarEventSettings.isPlannable'),
            field: 'isPlannable',
            cellRenderer: 'booleanRenderer',
            width: 150
          }
        ]
      },
      gridFrameworkComponents: {
        colorRenderer: ColorCellRenderer,
        booleanRenderer: BooleanCellRenderer
      },
      loading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>"
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isAddEnabled (): boolean {
      return !!this.profitCenterId
    },

    isEditEnable (): boolean {
      return !!this.currentSelectedRowId
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    }
  },

  methods: {
    onAddButtonClick (): void {
      this.currentSelectedEvent = undefined
      this.show = true
      this.action = MasterDataActionsEnum.Create
    },

    onEditButtonClick (): void {
      this.currentSelectedEvent = this.gridData.find((item: any) => item.id === parseInt(this.currentSelectedRowId))
      this.show = true
      this.action = MasterDataActionsEnum.Update
    },

    onRowClicked (params: any): void {
      this.currentSelectedRowId = params.node.data.id
    },

    onRowDoubleClicked (params: any) {
      this.currentSelectedRowId = params.node.data.id
      this.currentSelectedEvent = this.gridData.find((item: any) => item.id === parseInt(this.currentSelectedRowId))
      this.show = true
      this.action = MasterDataActionsEnum.Update
    },

    onSaveDialog (data: CalendarEventSettingsPayload): void {
      if (this.action === MasterDataActionsEnum.Create) {
        const payload: CalendarEventPayload = {
          action: this.action,
          id: null,
          eventId: data.eventId,
          profitCenterId: this.profitCenterId,
          color: data.color,
          isPlannable: data.isPlannable,
          language: null
        }
        this.saveCalendarEvent(payload)
      } else if (this.action === MasterDataActionsEnum.Update && this.currentSelectedEvent) {
        const payload: CalendarEventPayload = {
          action: this.action,
          id: this.currentSelectedEvent.id,
          eventId: this.currentSelectedEvent.eventId,
          profitCenterId: this.currentSelectedEvent.profitCenterId,
          color: data.color,
          isPlannable: data.isPlannable,
          language: this.currentSelectedEvent.language
        }
        this.saveCalendarEvent(payload)
      }
    },

    async saveCalendarEvent (data: CalendarEventPayload): Promise<void> {
      this.loading = true
      try {
        await this.$store.dispatch(COMPANY_UPDATE_DELETE_CALENDAR_EVENT, data)
        this.loading = false
        this.show = false
        this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
        this.snackbarState = SnackbarStateEnum.Success
        this.showSnackbar = true
        this.currentSelectedRowId = ''
        this.currentSelectedEvent = undefined
        this.fetchCalendarEventList()
      } catch (e) {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    onCloseDialog (): void {
      this.show = false
    },

    async fetchCalendarEventList (): Promise<void> {
      const data: Array<CalendarEvent> = await this.$store.dispatch(COMPANY_FETCH_PROFIT_CENTER_CALENDAR_EVENTS, { profitCenterId: this.profitCenterId })
      this.gridData = data
    }
  },

  async mounted () {
    this.fetchCalendarEventList()
  }
})
